module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAZCAMAAAAPIl6bAAAAY1BMVEUAAADHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zpBlTOAAAAIHRSTlMAEODoyzEWCO/SJiEa+tvWxLW9aGIqHgOrpZ2IdE9AOY8mEdcAAAB8SURBVBjTbc/ZEkQwEIXhiGEYmdj3Le//lHQUfYJz939VqkUIUQ2twJXG9K3T+7ovw2hoOcj0kOpPUoDMVjKQJbLisQQ+yQfkJ62ELComiUG8jCRV8NVx/epGU8vk7ES+tW7cq1pd7bsX6qNDbPyn4N4Rv4uBGoQat+bYG1DsDwzif9epAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_right.png
// module id = 172
// module chunks = 1